import './styles.scss'
import NoEventsImg from './noEvents.svg?react'

export const NoEvents = () => (
  <div className="no-events">
    <div className="no-events-text">
      Пока что здесь пусто, <br />
      но скоро появятся записи <br />о вашем малыше
    </div>
    <NoEventsImg />
  </div>
)
